import React from 'react';
import { Alert } from 'react-bootstrap';

const labels = { MARKETING: 'Marketing', UTILITY: 'Utilidade', AUTHENTICATION: 'Autenticacao' };
const money = value => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default function WhatsAppCostEstimate({ data }) {
  if (!data) return null;
  if (!data.available) return <Alert variant={'warning'} className={'m-3'}>
    Nao existe uma tarifa oficial vigente cadastrada para {labels[data.category] || data.category} em {data.market}.
  </Alert>;
  return <div className={'p-3 border-bottom'} style={{ background: '#f0fdf4' }}>
    <div className={'d-flex flex-wrap gap-4 align-items-center'}>
      <Value label={'Tarifa estimada por entrega'} value={money(data.unit_rate)} />
      <Value label={'Custo maximo estimado'} value={money(data.maximum_estimated_cost)} />
      <div className={'small text-muted'}>Categoria {labels[data.category] || data.category} - {data.eligible_messages} mensagens elegiveis.<br />
        A Meta cobra conforme entrega e regras da categoria; a fatura da Meta e o valor definitivo.<br />
        <a href={data.source_url} target={'_blank'} rel={'noreferrer'}>Consultar tabela oficial da Meta</a>
      </div>
    </div>
  </div>;
}

function Value({ label, value }) {
  return <div><small className={'text-muted d-block'}>{label}</small><strong>{value}</strong></div>;
}
